// extracted by mini-css-extract-plugin
module.exports = {"sectionHeadingContainer":"section-heading_sectionHeadingContainer__e3gIT","sectionHeading":"section-heading_sectionHeading__DR1tc","inverse":"section-heading_inverse__lG_Qq"};